import React from 'react';

export default function Button({ variant = 'primary', size = 'md', children, className = '', ...props }) {
  const base = "inline-flex items-center justify-center font-medium transition-colors rounded-md";
  
  const variants = {
    primary: "bg-slate-900 text-white hover:bg-slate-800 border border-transparent",
    secondary: "bg-white text-slate-700 hover:bg-slate-50 border border-slate-300",
    ghost: "bg-transparent text-slate-600 hover:bg-slate-100 border border-transparent",
    ai: "bg-purple-50 text-purple-700 hover:bg-purple-100 border border-purple-200"
  };

  const sizes = {
    sm: "text-xs px-2.5 py-1.5",
    md: "text-sm px-4 py-2",
    lg: "text-base px-6 py-3"
  };

  return (
    <button 
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}